import { render } from "./DrRSingh.vue?vue&type=template&id=4ed02188"
import script from "./DrRSingh.vue?vue&type=script&lang=js"
export * from "./DrRSingh.vue?vue&type=script&lang=js"

import "./DrRSingh.vue?vue&type=style&index=0&id=4ed02188&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__